import { Box, Fade, Grid, Tooltip, Typography } from "@mui/material";
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import BusinessBoxPreview from "../BusinessBoxPreview";
import { TooltipMUI } from "../../inputs.styled";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: "8px 0px",
    borderRadius: "4px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginTop: "5px",
    cursor: "pointer",
    // paddingLeft: "9px",
  },
  image: {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    marginBottom: "5px",
  },

  container: {
    maxHeight: "310px",
    overflowY: "auto",
    padding: "4px",
    borderRadius: "14px",
    // margin: "10px",
    // backgroundColor: "red",
  },
}));

function BusniessBoxGrid({
  allBusinessBoxes,
  handleSelect,
  selectedBoxCardData,
  handleCreateNewBB,
  isEditable,
}) {
  const classes = useStyles();

  const BusinessCards = (businessBox, id) => {
    return (
      <TooltipMUI
        placement="right"
        arrow
        title={
          <BusinessBoxPreview
            onlyBusinessBox={true}
            noBusinessBox={false}
            businessBoxData={businessBox}
            noEdit
            isTooltip
          />
        }
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        followCursor
      >
        <Box
          className={classes.box}
          onClick={() => handleSelect(businessBox)}
          style={{
            backgroundColor:
              selectedBoxCardData?.id === id ? "#D4E2F2" : "transparent",
          }}
        >
          <img
            alt="pbox"
            src={businessBox?.business_image}
            className={classes.image}
            style={{
              border:
                selectedBoxCardData?.id === id
                  ? "1px solid #123051"
                  : "0px solid black",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png";
            }}
          />
          <div title={businessBox?.name}>
            <Typography
              variant="h6"
              style={{
                fontSize: "8px",
                fontFamily: "DM Sans",
                textAlign: "center",
                // wordWrap: "break-word",
                // whiteSpace: "normal",
                // overflowWrap: "break-word",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "70px",
              }}
            >
              {businessBox?.name}
            </Typography>
          </div>
        </Box>
      </TooltipMUI>
    );
  };
  return (
    <Grid container spacing={0.2} className={classes.container}>
      {isEditable ? (
        <Grid item xs={4}>
          <Box className={classes.box} onClick={handleCreateNewBB}>
            <div
              alt="pbox"
              className={classes.image}
              style={{
                border: "1px solid #E1E1E1",
                backgroundColor: "#F6F7F9",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AddIcon
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                }}
              />
            </div>
            <div>
              <Typography
                variant="h6"
                style={{
                  fontSize: "8px",
                  fontFamily: "DM Sans",
                  textAlign: "center",
                  // wordWrap: "break-word",
                  // whiteSpace: "normal",
                  // overflowWrap: "break-word",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "70px",
                }}
              >
                Add New
              </Typography>
            </div>
          </Box>
        </Grid>
      ) : null}
      {allBusinessBoxes.map((businessBox, index) => (
        <Grid item xs={4} key={index}>
          {BusinessCards(businessBox, businessBox?.id)}
        </Grid>
      ))}
    </Grid>
  );
}

export default BusniessBoxGrid;
